import { getCurrentInstance } from "vue";

export function useSwal() {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error("useSwal ต้องเรียกภายใน setup()");
  }

  const swal = instance.proxy.$swal;

  return {
    swal,

    success(title, text = "") {
      return swal({
        icon: "success",
        title,
        text,
        timer: 1500,
        showConfirmButton: false,
      });
    },

    error(title, text = "") {
      return swal({
        icon: "error",
        title,
        text,
      });
    },

    confirm(
      title = "ยืนยันการทำรายการ",
      text = "คุณแน่ใจหรือไม่ ?"
    ) {
      return swal({
        icon: "warning",
        title,
        text,
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true,
      });
    },

    loading(title = "กำลังดำเนินการ...") {
      return swal({
        title,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading();
        },
      });
    },

    close() {
      swal.close();
    },
  };
}
